"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertOffset = convertOffset;
exports.currentDateTime = void 0;
exports.getBestFitTimeUnit = getBestFitTimeUnit;
exports.getDateTimeOffsetSeconds = getDateTimeOffsetSeconds;
var _TranslationKey = require("../models/TranslationKey");
const currentDateTime = () => new Date();
exports.currentDateTime = currentDateTime;
function getBestFitTimeUnit(timeOffset) {
  if (timeOffset <= 60) {
    // zero minutes -> now
    return _TranslationKey.TranslationKey.Now;
  }
  if (timeOffset < 3600) {
    // less then hour -> minutes
    return _TranslationKey.TranslationKey.Minute;
  }
  if (timeOffset < 86400) {
    // less then day -> hours
    return _TranslationKey.TranslationKey.Hour;
  }
  if (timeOffset < 604800) {
    // less then week -> days
    return _TranslationKey.TranslationKey.Day;
  } // more then week -> weeks

  return _TranslationKey.TranslationKey.Week;
}
function convertOffset(offset, timeFormat) {
  let multiplier = 0;
  switch (timeFormat) {
    case _TranslationKey.TranslationKey.Now:
    case _TranslationKey.TranslationKey.Minute:
      multiplier = 60;
      break;
    case _TranslationKey.TranslationKey.Hour:
      multiplier = 3600;
      break;
    case _TranslationKey.TranslationKey.Day:
      multiplier = 86400;
      break;
    case _TranslationKey.TranslationKey.Week:
      multiplier = 604800;
      break;
    default:
      break;
  }
  return Math.floor(offset / multiplier);
}
function getDateTimeOffsetSeconds(startDate, endDate) {
  return (endDate.getTime() - startDate.getTime()) / 1000;
}
